<template>
    <div class="bg-white w-100 rounded-4 d-flex flex-column gap-4 my-4 px-4">
        <div class="d-flex gap-5">
            <span class="w-50">
                <h1>Application Name*</h1>
                <Input
                    type="text"
                    label=""
                    name="Application Name"
                    class="field-container"
                    input_style="text-transform: capitalize;padding:10px"
                    v-model="applicationName"
                    @input="handleValues('application_name', $event)"
                    inputClass="input-add-new-client"
                    labelClass="class-label d-none"
                    placeholder="Enter Application Name"
                />
                <span class="text-danger">{{ errors.application_name }}</span>
            </span>
            <span class="w-50">
                <h1>Android/IOS App ID*</h1>
                <Input
                    type="text"
                    name="Android/IOS App ID"
                    class="field-container"
                    input_style="padding:10px"
                    v-model="appStoreId"
                    @input="handleValues('android_ios_id', $event)"
                    inputClass="input-add-new-client"
                    labelClass="class-label d-none"
                    placeholder="Enter Android/IOS App ID"
                    :disabled="!!$route.query.id"
                />
                <span class="text-danger">{{ errors.android_ios_id }}</span>
            </span>
        </div>

        <div class="d-flex gap-5">
            <span class="w-50">
                <h1>Company Name*</h1>
                <Multiselect
                    id="company"
                    track-by="id"
                    label="company_name"
                    placeholder="Select Company"
                    v-model="companyDetails"
                    @input="handleValues('company_belongs', $event.id)"
                    :options="companyList"
                    :searchable="true"
                    :allow-empty="false"
                    :show-labels="false"
                />
                <span class="text-danger">{{ errors.company_belongs }}</span>
            </span>
            <span class="w-50">
                <h1>Existing Dashboard (MH Home / MH Plus)*</h1>
                <Multiselect
                    id="company"
                    track-by="id"
                    label="dashboardName"
                    placeholder="Select Dashboard"
                    v-model="dashboardDetails"
                    @input="handleValues('dashboard_belongs', $event.id)"
                    :options="displaySelectedCompanyDashboards"
                    :searchable="true"
                    :allow-empty="false"
                    :show-labels="false"
                />
                <span class="text-danger">{{ errors.dashboard_belongs }}</span>
            </span>
        </div>

        <div class="d-flex gap-5">
            <div class="w-50 d-flex flex-column">
                <h3 style="font-size: 1.3rem" class="mb-2">App icon*</h3>
                <input
                    type="file"
                    name="app_logo"
                    id="app_logo"
                    accept=".jpg, .jpeg, .png, .webp"
                    hidden
                    @change="uploadImage"
                />
                <label for="app_logo" class="upload-section">
                    <span class="upload-section-title">Upload app icon</span>
                    <span
                        v-if="app_logo_loading"
                        class="upload-btn px-5 py-3 d-flex gap-3 px-4"
                        :class="app_logo_loading || !!$route.query.id ? 'btn-disabled' : ''"
                    >
                        <SpinLoader />Uploading
                    </span>
                    <span
                        v-else
                        class="upload-btn px-5 py-3 d-flex justify-content-center align-items-center gap-2"
                        :class="app_logo_loading"
                    >
                        <img src="@/assets/px/drag-and-drop/upload.svg" alt="" style="height: 25px" />
                        Upload Icon
                    </span>
                </label>
                <span v-if="app_logo_err" class="text-danger">{{ app_logo_err }}</span>
                <span v-if="errors.app_logo" class="text-danger">{{ errors.app_logo }}</span>
            </div>
            <div class="w-50 d-flex justify-content-center align-items-center mt-4">
                <div
                    class="d-flex justify-content-center align-items-center"
                    style="width: 15rem; height: 8rem; border: 2px dashed #d7d7d7; border-radius: 15px"
                >
                    <img v-if="app_logo" :src="app_logo" alt="" style="height: 5rem; border-radius: 15px" />
                    <img v-else src="@/assets/px/drag-and-drop/photo-gallery.svg" alt="" style="height: 5rem" />
                </div>
            </div>
        </div>

        <div class="d-flex gap-5">
            <span class="w-50">
                <h1>Project Tags</h1>
                <Multiselect
                    id="projectTags"
                    track-by="name"
                    label="name"
                    placeholder="Search or Select Tags"
                    v-model="selectedTags"
                    :options="tagsList"
                    :searchable="true"
                    :show-labels="false"
                    :multiple="true"
                    :clear-on-select="false"
                    :close-on-select="false"
                    @input="handleValues('project_tags', $event)"
                />
            </span>
        </div>
    </div>
</template>

<script>
    import SpinLoader from '@/components/general/loading/SpinLoader.vue';
    import Multiselect from 'vue-multiselect';
    import { dashboardBuilder, upload, companies } from '@/util/apiRequests';

    export default {
        name: 'ApplicationDetails',
        components: { SpinLoader, Multiselect },
        props: {
            applicationId: {
                type: Number,
            },
            applicationData: {
                type: Object,
            },
            companyList: {
                type: Array,
            },
            dashboardList: {
                type: Array,
            },
            errors: {
                type: Object,
            },
        },
        data() {
            return {
                applicationName: null,
                appStoreId: null,
                companyDetails: null,
                dashboardDetails: null,
                app_logo: null,
                app_logo_loading: false,
                app_logo_err: null,
                tagsList: [],
                selectedTags: [],
            };
        },
        computed: {
            displaySelectedCompanyDashboards() {
                if (!this.companyDetails) return [];
                return this.dashboardList.filter((dashboard) => dashboard.company_id === this.companyDetails.id);
            },
        },
        methods: {
            async geturl(fileId) {
                const endpoint = upload.getUrl();
                const response = await this.$api.post(endpoint, { fileId });
                if (!response.data.success) {
                    throw response.data.error;
                }
                return response.data.url;
            },
            async uploadImage(event) {
                const file = event.target.files[0];
                if (!file) return;

                const fileExtension = file.name.split('.').pop().toLowerCase();
                const allowedExtensions = ['png', 'jpg', 'jpeg', 'webp'];
                const type = event.target.name;

                let err = 0,
                    errMsg;

                if (!allowedExtensions.includes(fileExtension)) {
                    err++;
                    errMsg = 'Only PNG, JPG, JPEG, and WEBP files are allowed';
                }

                if (file.size / 1024 / 1024 > 10) {
                    err++;
                    errMsg = 'File size should not be greater than 10MB';
                }

                if (err) {
                    this.app_logo_err = errMsg;
                    this.$toasted.error(errMsg);
                    return;
                }

                this.$emit('handlePageChangeDisabled', true);
                this.app_logo_loading = true;

                var reader = new FileReader();
                reader.readAsDataURL(file);
                let that = this;

                reader.onload = async function () {
                    const img = new Image();
                    img.src = reader.result;

                    img.onload = async function () {
                        let formData = new FormData();
                        formData.append('file', file);
                        formData.append('type', type);

                        const endpoint = dashboardBuilder.uploadImageAssets(that.applicationId, type, 0, 'public');
                        let response = await that.$api.post(endpoint, formData);

                        if (!response.data.success) {
                            throw response.data.error;
                        }

                        that.app_logo = await that.geturl(response.data.s3_link);
                        that.app_logo_loading = false;
                        that.app_logo_err = null;
                        that.$emit('handlePageChangeDisabled', false);
                        that.handleValues(type, response.data.s3_link);
                    };
                };
                reader.onerror = function (error) {
                    that.app_logo_err = null;
                    that.app_logo_loading = false;
                    that.$emit('handlePageChangeDisabled', false);
                    that.$toasted.error('Failed to upload image', error);
                };
            },
            handleValues(type, value) {
                if (type === 'company_belongs') {
                    this.dashboardDetails = null;
                    this.handleValues('dashboard_belongs', null);
                }
                this.errors[type] = null;
                this.$emit('captureValues', { applicationData: { [type]: value } });
            },
            async fetchTags() {
                try {
                    let res = await this.$api.get(companies.getTags(this.$store.state.user.company_id));
                    if (res.data.success) {
                        this.tagsList = res.data.info;
                    }
                } catch (err) {
                    console.log('err', err);
                }
            },
        },
        async created() {
            window.scrollTo(0, 0);
            await this.fetchTags();

            const { application_name, android_ios_id, company_belongs, dashboard_belongs, app_logo, project_tags } =
                this.applicationData;

            if (application_name) {
                this.applicationName = application_name;
            }

            if (android_ios_id) {
                this.appStoreId = android_ios_id;
            }

            if (company_belongs) {
                this.companyDetails = this.companyList.find((company) => company.id == company_belongs);
            }

            if (dashboard_belongs) {
                this.dashboardDetails = this.dashboardList.find((dashboard) => dashboard.id == dashboard_belongs);
            }

            if (app_logo) {
                this.app_logo = await this.geturl(app_logo);
            }

            if (project_tags) {
                this.selectedTags = project_tags;
            }
        },
    };
</script>

<style scoped>
    .upload-section {
        border-radius: 10px;
        border: 2px solid #d7d7d7;
        background: #fff;
        box-shadow: 0px 20px 5px 0px rgba(0, 0, 0, 0.03);
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .upload-section-title {
        font-size: 1rem;
        margin-left: 1rem;
        color: #7c7979;
        font-weight: 600;
    }

    .upload-btn {
        border-radius: 6px;
        background: #5155c3;
        color: #fff;
        font-family: 'Roboto';
        box-shadow: 0px 20px 5px 0px rgba(0, 0, 0, 0.03);
    }

    .btn-disabled {
        cursor: not-allowed;
        opacity: 0.8;
    }
</style>
